import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import sampleImage from '../../assets/images/dashboard/body/tasksImg.svg';
import search from "../../assets/images/dashboard/body/Search.svg"
import taskTick from '../../assets/images/dashboard/body/taskTick.svg';
import twenty from '../../assets/images/dashboard/body/20.svg';

const TaskdetailModal = ({ isOpen, onClose }) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [startTime, setStartTime] = useState(null);
    if (!isOpen) return null;

    const handleBackgroundClick = (e) => {
        // If the user clicks on the background (outside the modal), close the modal
        if (e.target === e.currentTarget) {
            onClose();
        }
    };


    return (
        <div >
            <div onClick={handleBackgroundClick} className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
                <div className=" bg-[#F6F2EF] p-4 mx-2 md:mx-0 w-full max-w-[500px] rounded-lg shadow-lg md:p-6 relative">

                    <button className='absolute right-3 top-3 text-black' onClick={onClose}>
                        &#10006;
                    </button>

                    <div className="mb-4">
                        <div className="flex justify-between">

                            <img
                                src={sampleImage}
                                alt="Task"
                                className="w-[156px] h-[158px] rounded-md"
                            />

                            <div className='w-full ml-[16px] mt-3'>
                                <div className='relative items-center flex w-full'>
                                    <input type="search" placeholder='Search' className='w-full h-6 border-0 text-[10px] rounded-lg' />
                                    <img src={search} alt="search" className='absolute right-[15px] w-[10px] h-[10px] ' />
                                </div>

                                <div className='flex mt-[15px] justify-between'>
                                    <div className="">
                                        <p>Cleaning</p>

                                        <p className='py-[15px] text-xs'>
                                            Priority: <span className=" text-red-500">Extreme</span>
                                        </p>

                                        <p className='text-xs'>
                                            Status: <span className=" text-red-500">Not Started</span>
                                        </p>

                                        <p className='text-[10px] text-[#A1A3AB] pt-3'>
                                            Created on: 20/06/2023
                                        </p>
                                    </div>

                                    <div className='text-right'>
                                        <p className='text-xs mb-3'>
                                            Reward
                                        </p>

                                        <div className="flex  items-center justify-center token_box_right">
                                            <div className="coupon-container token_box flex items-center justify-between border  bg-white rounded-sm shadow-sm">
                                                <div className="coupon-logo  py-2 px-3 flex justify-center items-center">
                                                    <img src={taskTick} alt="Task Tick" />
                                                </div>

                                                <div className="coupon-info py-2 px-3 flex flex-col items-center border-l-[0.5px] border-dashed">
                                                    <img src={twenty} alt="20$ Off" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p>Curabitur pretium tincidunt lacus. Nulla gravida orci a odio. </p>

                        <p className="mt-[10px] text-sm">
                            Curabitur pretium tincidunt lacus. Nulla gravida orci a odio.
                            Nullam varius, turpis et commodo pharetra, est velit tempus eros, nec
                            ultricies eros sapien id orci. Vivamus suscipit, lorem nec egestas tincidunt,
                            est mauris ullamcorper nulla, nec luctus orci purus et elit. Integer                         </p>

                    </div>

                    <div className='flex w-full justify-around'>
                        <DatePicker
                            selected={startTime}
                            onChange={(time) => setStartTime(time)}
                            showTimeSelect
                            placeholderText="Select Time"
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            className="w-full px-4 h-[23px] text-[10px]  border  rounded-md"
                        />

                        <div className="relative flex justify-center items-center  w-fit">
                            <DatePicker
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                placeholderText="Select Date"
                                dateFormat="MMMM d, yyyy"
                                className="w-full px-4 h-[23px] text-[10px] border rounded-md focus:outline-none focus:ring-2 "
                                calendarClassName="custom-calendar"
                                dayClassName={(date) =>
                                    date.getDate() === new Date().getDate() ? "bg-purple-100 text-purple-600" : ""
                                }
                            />
                        </div>
                    </div>

                    <button className="w-[143px] h-[32px] flex justify-center items-center text-white mx-auto text-[13px] bg-[#C6AFFF] rounded-lg mt-28 ">
                        Submit
                    </button>
                </div>
            </div>
        </div>
    )
}

export default TaskdetailModal